export var datepickerCalendarStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      minHeight: v.calendarMinHeight
    };
  }
};
//# sourceMappingURL=datepickerCalendarStyles.js.map
